import React from 'react';
import PropTypes from 'prop-types';


const ContactCardField = ({ field, contact, handleOpenViewModal }) => {
  if (field.key === 'actions') {
    return (
      <div className="flex mt-2 space-x-2">
        <button
          className="text-sss-info mr-2"
          onClick={() => handleOpenViewModal(contact.contactId || contact.id || contact.contactID)}
        >
          View
        </button>
      </div>
    );
  }

  if (field.key === 'contactName') {
    return (
      <p className="text-xl font-bold">{contact.contactName}</p>
    );
  }

  return (
    <p className="text-sm text-gray-600">
      {field.label}:{' '}
      {typeof contact[field.key] === 'boolean'
        ? contact[field.key]
          ? '✅'
          : '-'
        : contact[field.key] != null
        ? contact[field.key].toString()
        : '-'}
    </p>
  );
};

ContactCardField.propTypes = {
  field: PropTypes.object.isRequired,
  contact: PropTypes.object.isRequired,
  handleOpenViewModal: PropTypes.func.isRequired,
};

export default ContactCardField;
